import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Planning/generarExcelVerracosPlanificados`, method: 'GET', body: null, token: token})
}